<template>
  <div>
    <div class="fixed">
      <div class="top_header">
        <div class="m_flex_box flex_vc flex_jz">
          <div class="m_flex_box flex_vc">
            <van-icon
              name="arrow-left"
              class="mar_r"
              @click="goback"
              size="0.4rem"
            />
          </div>
          <div
            style="text-align: center; font-size: 0.35rem; margin-left: -0.2rem"
          >
            物业咨询
          </div>
          <div></div>
        </div>
      </div>
    </div>
    <div class="fixed_pad"></div>
    <div>
      <van-form :scroll-to-error="true">
        <van-field
          v-model="oneData"
          type="text"
          label="查询小区:"
          placeholder="请输入小区名称"
          maxlength="10"
        >
          <template #button>
            <van-button size="small" type="primary" @click="queryCommunityName"
              >查询</van-button
            >
          </template>
        </van-field>
      </van-form>
    </div>
    <div class="detail" v-for="item in listData" :key="item.wyqydm">
      <div>
        <span>小区名称:</span>
        {{ item.wyqymc }}
      </div>
      <div>
        <span>小区地址:</span>
        {{ item.xxdz }}
      </div>
    </div>
  </div>
</template>
<script>
import qs from "qs";
export default {
  data() {
    return {
      oneData: "",
      listData: [],
    };
  },
  components: {},
  methods: {
    goback() {
      if ((this.isApp && this.isApp != "false") || this.isApp == "true") {
        let u = navigator.userAgent;
        let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //g
        let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        if (isAndroid) {
          window.android.goback(); // 调用原生app的函数
        }
        if (isIOS) {
          window.webkit.messageHandlers.goback.postMessage(null);
        }
        // window.webkit.messageHandlers.goback.postMessage(null);
      } else {
        this.$router.go(-1);
      }
    },
    queryCommunityName() {
      var item = {
        wyqymc: this.oneData,
      };
      this.$http
        .post("house/wyts/getWyArea.do", qs.stringify(item))
        .then((res) => {
          if (res.success) {
            this.listData = res.obj;
          }
        });
    },
  },
};
</script>
<style lang="less" scoped>
.fixed_pad {
  padding-top: 1.1rem;
}
.top_header {
  height: 0.5rem;
  padding: 0.2rem 0rem;
  width: 7.04rem;
  margin: 0 auto;
}
.fixed {
  border-bottom: 1px solid #f5f5f5;
  background-color: #fff;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  z-index: 9;
  .top_normal {
    height: 100%;
    i {
      font-size: 0.32rem;
    }
  }
}
.detail {
  padding: 0.2rem 0.3rem;
  font-size: 0.28rem;
  border-bottom: 1px solid #ccc;
  div {
    line-height: 0.45rem;
    color: #ccc;
    span {
      color: #000;
    }
  }
}
</style>